import {useUser} from "../../../context/UserContext";
import {MessageCodes} from "../MessageCodes";
import ResultText from "../ResultText";
import EmptyLine from "../EmptyLine";
import ResultTable from "../../../components/table/ResultTable";
import ResultHeader from "../../../components/table/ResultHeader";
import ResultHeaderCell from "../../../components/table/ResultHeaderCell";
import ResultRow from "../../../components/table/ResultRow";
import HecRasHelper from "../../../helpers/HecRasHelper";
import ResultBody from "../../../components/table/ResultBody";
import ResultBodyCell from "../../../components/table/ResultBodyCell";
import ResultView from "../../../components/ResultView";

export function FL5({data, message_key}) {
    const {settings} = useUser()

    return (
        <>
            {
                data?.result?.map(row => (
                    <ResultView error_id={row?.error_id} message_key={message_key}>
                        <Description row={row} settings={settings} globalVariables={data?.global_variables} />
                    </ResultView>
                ))
            }
        </>
    )
}

const Description = ({text, row, settings, globalVariables}) => {
    switch (row.error_id) {
        case MessageCodes.Internal.FL07.error_id: {
            return (
                <>
                    <ResultText>
                        Normal Depth Slope is not within the defined range {settings?.thresholds?.normal_depth_slope_min} - {settings?.thresholds?.normal_depth_slope_max} at the highlighted profiles. The channel slope between the two most downstream cross sections ({row?.ds_chn?.toFixed(2)} ft apart) is {row?.ds_chn_slope?.toFixed(4)}.
                    </ResultText>
                    <EmptyLine />
                    <ResultTable data={row?.data?.map(r => ({csName: r.cross_section, csNameVal: r.cross_section}))}>
                        <ResultHeader>
                            <ResultRow>
                                <ResultHeaderCell style={{width: HecRasHelper.getWidth(15)}}>Profile</ResultHeaderCell>
                                <ResultHeaderCell style={{width: HecRasHelper.getWidth(20), textAlign: 'end'}}>Downstream</ResultHeaderCell>
                                <ResultHeaderCell style={{width: HecRasHelper.getWidth(15), textAlign: 'end'}}>E.G. Slope</ResultHeaderCell>
                            </ResultRow>
                        </ResultHeader>
                        <ResultBody>
                            {
                                row?.data[0]?.normal_depths?.map(r => {
                                    let is_not_red = (settings?.thresholds?.normal_depth_slope_min <= r?.downstream) && (r?.downstream <= settings?.thresholds?.normal_depth_slope_max)
                                    if(r?.name !== 'Normal Depth S')
                                       is_not_red = true
                                    return (
                                        <ResultRow>
                                            <ResultBodyCell style={{width: HecRasHelper.getWidth(15)}}>{r.profile}</ResultBodyCell>
                                            <ResultBodyCell style={{width: HecRasHelper.getWidth(20), textAlign: 'end', fontWeight: 'normal'}}>
                                                {r?.name} = <span style={{color: is_not_red ? '' : 'red' }}>{r?.downstream}</span>
                                            </ResultBodyCell>
                                            <ResultBodyCell style={{width: HecRasHelper.getWidth(15), textAlign: 'end'}}>
                                                {r?.eg_slope}
                                            </ResultBodyCell>
                                        </ResultRow>
                                    )
                                })
                            }
                        </ResultBody>
                    </ResultTable>
                </>
            )
        }
    }
}